import { render, staticRenderFns } from "./Fourth_mobile.vue?vue&type=template&id=60cbe5d9&"
import script from "./Fourth_mobile.vue?vue&type=script&lang=js&"
export * from "./Fourth_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Fourth_mobile.vue?vue&type=style&index=0&id=60cbe5d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports